import { cn } from "@/lib/utils";
import * as React from "react";
import { Outlet } from "react-router-dom";

export interface IAuthLayoutProps {}

export default function AuthLayout(props: IAuthLayoutProps) {
  return (
    <div className="dark bg-background text-foreground w-full h-screen lg:grid lg:min-h-[600px] lg:grid-cols-2 xl:min-h-[800px]">
      <div className="flex flex-col items-center justify-center py-12 gap-6">
        <img src="/img/logo.png" alt="Image" className="w-44 object-contain" />
        <Outlet />
      </div>
      <div className="hidden bg-dark lg:block">
        <img
          src="/img/astronaut-head-2.png"
          alt="Image"
          width="1920"
          height="1080"
          className="h-full w-full object-contain object-bottom dark:brightness-[0.2] dark:grayscale"
        />
      </div>
    </div>
  );
}
